export default __webpack_public_path__ + "static/media/red-bullet.2fe8e714.svg";